var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/tree/Location",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mbri-photo",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0C0.3616 0 0 0.3616 0 0.8L0 15.2C0 15.6384 0.3616 16 0.8 16L15.2 16C15.6384 16 16 15.6384 16 15.2L16 0.8C16 0.3616 15.6384 0 15.2 0L0.8 0ZM15.2 0.533333L0.8 0.533333C0.647467 0.533333 0.533333 0.647467 0.533333 0.8L0.533333 15.2C0.533333 15.3525 0.647467 15.4667 0.8 15.4667L15.2 15.4667C15.3525 15.4667 15.4667 15.3525 15.4667 15.2L15.4667 0.8C15.4667 0.647467 15.3525 0.533333 15.2 0.533333ZM4.53333 3.2C3.8 3.2 3.2 3.8 3.2 4.53333C3.2 5.26667 3.8 5.86667 4.53333 5.86667C5.26667 5.86667 5.86667 5.26667 5.86667 4.53333C5.86667 3.8 5.26667 3.2 4.53333 3.2ZM5.33333 4.53333C5.33333 4.08853 4.97813 3.73333 4.53333 3.73333C4.08853 3.73333 3.73333 4.08853 3.73333 4.53333C3.73333 4.97813 4.08853 5.33333 4.53333 5.33333C4.97813 5.33333 5.33333 4.97813 5.33333 4.53333ZM11.2891 6.4L11.288 6.4C11.074 6.40037 10.8835 6.51064 10.7451 6.656L7.5488 10.0139C7.41013 10.1685 7.2592 10.1568 7.1264 10.0139L5.52853 8.28053C5.36853 8.10773 5.16267 8.0032 4.93813 8C4.71307 7.99733 4.504 8.10933 4.34347 8.2896L1.68533 11.2725C1.42933 11.5285 1.824 11.9179 2.0784 11.6363L4.7376 8.65333C4.92693 8.43467 5.07147 8.5712 5.15147 8.66293L6.74933 10.3963C6.90827 10.5696 7.1152 10.6667 7.33707 10.6667C7.55893 10.6667 7.76373 10.5669 7.9248 10.3968L11.1211 7.0384C11.2864 6.86933 11.4507 6.952 11.5435 7.0384L13.9365 9.51093C14.1872 9.77653 14.5749 9.38293 14.3136 9.128L11.92 6.656C11.74 6.46963 11.5122 6.40022 11.2891 6.4ZM14.1333 12.8L1.86667 12.8C1.71893 12.8 1.6 12.9189 1.6 13.0667C1.6 13.2144 1.71893 13.3333 1.86667 13.3333L14.1333 13.3333C14.2811 13.3333 14.4 13.2144 14.4 13.0667C14.4 12.9189 14.2811 12.8 14.1333 12.8Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.0b6885cf8192ee8e1942a9e6c24bcc26.svg";
export { ForwardRef as ReactComponent };